import React from "react";
import { Container } from "reactstrap";
import JobListing from "./JobListing";
import Section from "./Section";
import Selected from "./Selected";
import StatusDashboard from "./StatusDashboard";
import VerificationModal from "./VerificationModal"

const ManageJobs = () => {
  document.title = "Avanza Empleos | Administrar trabajos";
  return (
    <React.Fragment>
      <VerificationModal />
      <Section />
      <section className="section">
        <Container>
          <StatusDashboard />
          <Selected />          
          <JobListing />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageJobs;
